import { render, staticRenderFns } from "./DemoShowCardLarge.vue?vue&type=template&id=45470d44&scoped=true"
import script from "./DemoShowCardLarge.vue?vue&type=script&lang=ts"
export * from "./DemoShowCardLarge.vue?vue&type=script&lang=ts"
import style0 from "./DemoShowCardLarge.vue?vue&type=style&index=0&id=45470d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45470d44",
  null
  
)

export default component.exports